import { useState } from "react";
import { loadSONumberWiseChildRollList } from "../services/storageLocationService";

const useGetChildRollListBySONumber = (editID) => {
    const [childRollList, setChildRollList] = useState([]);
    const [selectedChildRollID, setSelectedChildRollID] = useState([]);
    const [childRollLoading, setChildRollLoading] = useState(false);
    const [emptyReelMessage, setEmptyReelMessage] = useState('');


    // Fetch sales order numbers
    const fetchRequestIndentNumber = async (soNumber, lineNumber) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_so_number: soNumber.so_number,
            p_line_no: lineNumber,
        };

        setChildRollLoading(true); // Show loader
        try {
            const data = await loadSONumberWiseChildRollList(para);
            if (data && data.length > 0) {
                setChildRollList(data);
                setEmptyReelMessage('');
            }
            else{
                setEmptyReelMessage('No Valid Reel Available For transfer process.');
                 setChildRollList([]);
            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setChildRollLoading(false); // Hide loader after fetching
        }
    };


    // Function to update selected sales order number
    const loadChildRollBasedOnSoNumber = (soNumber, lineNumber) => {
        fetchRequestIndentNumber(soNumber, lineNumber);
    };

    const clearChildRollList = async () => {
        setChildRollList([]);
    };

    return {
        childRollList,
        selectedChildRollID,
        setChildRollList,
        setSelectedChildRollID,
        loadChildRollBasedOnSoNumber,
        childRollLoading,
        setChildRollLoading,
        clearChildRollList,
        emptyReelMessage,
        setEmptyReelMessage
    };
};

export default useGetChildRollListBySONumber;
